import { jsx as r, jsxs as c } from "react/jsx-runtime";
import { forwardRef as e } from "react";
import { useMultiStyleConfig as n, chakra as m } from "@chakra-ui/react";
import { LocationPickerComponent as a } from "./LocationPicker.component.es.js";
import { useLocationPicker as f, LocationPickerProvider as s, LocationPickerStylesProvider as l } from "./LocationPicker.context.es.js";
import { LocationPickerInput as P } from "./components/LocationPicker.input.es.js";
const p = e((o, k) => {
  const i = "ctx" in o && o.ctx ? o.ctx : f(o), t = n("LocationPicker", {});
  return /* @__PURE__ */ r(s, { value: i, children: /* @__PURE__ */ r(l, { value: t, children: /* @__PURE__ */ c(m.div, { __css: t.root, children: [
    /* @__PURE__ */ r(P, {}),
    /* @__PURE__ */ r(a, {})
  ] }) }) });
});
export {
  p as LocationPicker
};
//# sourceMappingURL=LocationPicker.container.es.js.map
